import Text from "./text";

export { Text };
